export default function getSpanishDayName() {
  const date = new Date()
  return date.toLocaleDateString("es-CL", { weekday: "long" }).toLocaleLowerCase()
}
